module.exports = {
      id: "dislike-color-usage",
      viewBox: "0 0 25 23",
      url: "img/" + "sprite.svg#dislike-color-usage",
      toString: function () {
        return this.url;
      }
    }